import React from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TableCell,
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Box,
  makeStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import PropTypes from "prop-types";
import AlertDialog from "../AlertDialog";
import moment from "moment";

// Styles
const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: "342px",
  },
  tableCell: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: 220,
    textOverflow: "ellipsis",
  },
}));

const TableWithDeleteButton = ({
  title = "Title",
  toolbarIconClick = () => {},
  items = [],
  headers = [],
  noRecordsMessage = "",
  item = {},
  toolbarDeleteIconClick = () => {},
}) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <AppBar position="static">
        <Toolbar>
          <Grid
            container
            alignItems="center"
            justify="space-between"
            id="grid_icons_container_aligned"
          >
            <Typography variant="h6">{title}</Typography>
            {item && item.id ? (
              <Box display="flex" alignItems="center">
                <AlertDialog
                  openButton="icon"
                  openButtonColor="inherit"
                  dialogTitle="Remove product message"
                  dialogContentText="The product message will no longer be available. Do you want to continue?"
                  confirmButtonClick={toolbarDeleteIconClick}
                  confirmButtonText="Continue"
                  confirmButtonColor="primary"
                  closeButtonText="Cancel"
                />
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={toolbarIconClick}
                >
                  <EditIcon />
                </IconButton>
              </Box>
            ) : (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toolbarIconClick}
              >
                <AddIcon />
              </IconButton>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      {items && items.length ? (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell colSpan={header.colSpan} key={index}>
                    <Box fontWeight="bold">{header.name}</Box>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row, index) => (
                <TableRow key={index}>
                  {Object.keys(row).map((keyName, keyIndex) =>
                    row[keyName] && typeof row[keyName] == "object" ? (
                      <TableCell
                        key={keyIndex}
                        align={row[keyName].align}
                        className={classes.tableCell}
                      >
                        {row[keyName].content}
                      </TableCell>
                    ) : keyName != "id" ? (
                      <TableCell key={keyIndex} className={classes.tableCell}>
                        {row[keyName]}
                      </TableCell>
                    ) : (
                      ""
                    ),
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : item && item.id ? (
        <Paper style={{ padding: "12px 16px" }}>
          <Typography variant="caption" color="textSecondary">
            Info message
          </Typography>
          <Typography variant="body2" gutterBottom>
            {item.message}
          </Typography>
          <Grid container spacing={2} style={{ marginTop: "4px" }}>
            <Grid item xs={6}>
              <Typography variant="caption" color="textSecondary">
                Start Date
              </Typography>
              <Typography variant="body2">
                {item.startDate
                  ? moment(item.startDate).format("MM/DD/YY")
                  : "—"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" color="textSecondary">
                End Date
              </Typography>
              <Typography variant="body2">
                {item.endDate ? moment(item.endDate).format("MM/DD/YY") : "—"}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      ) : (
        <Paper>
          <Typography variant="h6" gutterBottom>
            {noRecordsMessage}
          </Typography>
        </Paper>
      )}
    </React.Fragment>
  );
};

TableWithDeleteButton.propTypes = {
  title: PropTypes.string,
  toolbarIconClick: PropTypes.func,
  headers: PropTypes.array,
  items: PropTypes.array,
  noRecordsMessage: PropTypes.string,
  item: PropTypes.object,
  toolbarDeleteIconClick: PropTypes.func,
};

export default TableWithDeleteButton;
